module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "Contents"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454932918_epub_itr_r1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454932918_epub_p01_r1"
    }
  }, [_c('span', {
    staticClass: "color4"
  }, [_c('b', [_c('i', [_vm._v("Part One")]), _c('br'), _c('span', {
    staticClass: "toc_part1"
  }, [_vm._v("PLANT CARE BASICS")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c01_r1"
    }
  }, [_vm._v("The Path to Enlightenment: Understanding Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c02_r1"
    }
  }, [_vm._v("Water World: The When, Where, How, and Why of Watering")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh, the Humidity: Why It (Sometimes) Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soiled Again: Understanding Potting Mixes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let’s Go Shopping!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hey, Good Looking: How to Groom Your Plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moving On: Repotting Your Plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now What’s Wrong? Common Plant Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Propagation: Or, How to Make More Plant Friends")]), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color4"
  }, [_c('b', [_c('i', [_vm._v("Part Two")]), _c('br'), _c('span', {
    staticClass: "toc_part1"
  }, [_vm._v("PLANT PROFILES")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("African Violet ("), _c('em', [_vm._v("Saintpaulia")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air Plants ("), _c('em', [_vm._v("Tillandsia")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aloe Vera")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amaryllis ("), _c('em', [_vm._v("Hippeastrum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arrowhead Plant ("), _c('em', [_vm._v("Syngonium podophyllum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bird’s Nest Fern ("), _c('em', [_vm._v("Asplenium nidus")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston Fern ("), _c('em', [_vm._v("Nephrolepis exaltata")]), _vm._v("‘Bostoniensis’)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braided Money Tree ("), _c('em', [_vm._v("Pachira aquatica")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cast Iron Plant ("), _c('em', [_vm._v("Aspidistra elatior")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Evergreen ("), _c('em', [_vm._v("Aglaonema")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Money Plant ("), _c('em', [_vm._v("Pilea peperomioides")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Cactus ("), _c('em', [_vm._v("Schlumbergera buckleyi")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dieffenbachia ("), _c('em', [_vm._v("Dieffenbachia seguine")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Donkey’s Tail ("), _c('em', [_vm._v("Sedum morganianum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dwarf Umbrella Tree ("), _c('em', [_vm._v("Schefflera arboricola")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Echeveria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English Ivy ("), _c('em', [_vm._v("Hedera helix")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fiddle-Leaf Fig ("), _c('em', [_vm._v("Ficus lyrata")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flaming Katy ("), _c('em', [_vm._v("Kalanchoe blossfeldiana")]), _vm._v(")")]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golden Barrel Cactus ("), _c('em', [_vm._v("Echinocactus grusonii")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heartleaf Philodendron ("), _c('em', [_vm._v("Philodendron hederaceum")]), _vm._v(", syn. "), _c('em', [_vm._v("Philodendron scandens")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inch Plant ("), _c('em', [_vm._v("Tradescantia zebrina")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jade Plant ("), _c('em', [_vm._v("Crassula ovata")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c33_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lady Slipper Orchid ("), _c('em', [_vm._v("Paphiopedilum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c34_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Lime Dracaena ("), _c('em', [_vm._v("Dracaena deremensis")]), _vm._v(" ‘Lemon Lime’)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c35_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucky Bamboo ("), _c('em', [_vm._v("Dracaena sanderiana")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c36_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meyer Lemon Tree ("), _c('em', [_vm._v("Citrus")]), _vm._v(" × "), _c('em', [_vm._v("meyeri")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c37_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monstera ("), _c('em', [_vm._v("Monstera deliciosa")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c38_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moth Orchid ("), _c('em', [_vm._v("Phalaenopsis")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c39_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nerve Plant ("), _c('em', [_vm._v("Fittonia")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c40_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norfolk Island Pine ("), _c('em', [_vm._v("Araucaria heterophylla")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c41_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Oxalis triangularis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c42_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Panda Plant ("), _c('em', [_vm._v("Kalanchoe tomentosa")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c43_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parlor Palm ("), _c('em', [_vm._v("Chamaedorea elegans,")]), _vm._v(" syn. "), _c('em', [_vm._v("Neanthe bella")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c44_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peace Lily ("), _c('em', [_vm._v("Spathiphyllum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c45_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Polka Dot Plant ("), _c('em', [_vm._v("Hypoestes phyllostachya")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c46_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ponytail Palm ("), _c('em', [_vm._v("Beaucarnea recurvata")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c47_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pothos ("), _c('em', [_vm._v("Epipremnum aureum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c48_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer Plant ("), _c('em', [_vm._v("Maranta leuconeura")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c49_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rex Begonia ("), _c('em', [_vm._v("Begonia rex")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c50_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rubber Plant ("), _c('em', [_vm._v("Ficus elastica")]), _vm._v(")")]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c51_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snake Plant ("), _c('em', [_vm._v("Sansevieria trifasciata")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c52_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spider Plant ("), _c('em', [_vm._v("Chlorophytum comosum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c53_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staghorn Fern ("), _c('em', [_vm._v("Platycerium bifurcatum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c54_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tree Philodendron ("), _c('em', [_vm._v("Philodendron bipinnatifidum")]), _vm._v(", syn. "), _c('em', [_vm._v("Philodendron selloum")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c55_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Urn Plant ("), _c('em', [_vm._v("Aechmea fasciata")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c56_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Peperomia ("), _c('em', [_vm._v("Peperomia argyreia")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c57_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wax Plant ("), _c('em', [_vm._v("Hoya carnosa")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c58_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zebra Plant ("), _c('em', [_vm._v("Haworthia fasciata")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_c59_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ZZ Plant ("), _c('em', [_vm._v("Zamioculcas zamiifolia")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_res_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RESOURCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_bib_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454932918_epub_cre_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IMAGE CREDITS")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-844758b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454932918_epub_toc_r1.vue
// module id = 72
// module chunks = 0